import React, { useEffect, useState } from "react";
import { normativeService } from "../../Services/normative.service";
import { useTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";
import SpinnerLoading from "../Common/SpinnerLoading";
import { numbersAndDot } from "../../Config/Regex";
import ResultModal from "../Common/ResultModal";
import NormativesFilterModal from "../Common/NormativesFilterModal";
import ListAdminButtons from "../Common/ListAdminButtons";

const ItemNormative = ({ productGuid, tenantId }) => {
  const { t: translator } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(true);
  const [normatives, setNormatives] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [update, setUpdate] = useState(new Date());
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });
  const [showFilterModal, setShowFilterModal] = useState(false);

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    setIsDisabled(true);
  };

  useEffect(() => {
    normativeService
      .getItemNormatives(productGuid)
      .then((res) => {
        let mappedNormatives = res.data.map((i) => ({
          normativGuid: i.guid,
          name: i.name,
          unitOfMeasureName: i.unitOfMeasureName,
          productGuid: i.productGuid,
          quantity: i.quantity,
          isActive: i.isActive,
        }));

        console.log("mp", mappedNormatives);
        setNormatives(mappedNormatives);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
  }, [update]);

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const handleSubmit = () => {
    normativeService
      .updateNormativeList(productGuid, normatives)
      .then((res) => {
        setUpdate(new Date());
        res.data.success
          ? setResultModal({
              show: true,
              title: translator("EditItem-UpdateItem-SuccesModal-Title"),
              text: translator("EditItem-UpdateItem-SuccesModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setResultModal({
              show: true,
              title: translator("EditItem-Update-UnsuccessModal-Title"),
              text: translator("EditItem-Update-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) => console.log(err));
  };

  const options = {
    sizePerPage: 50,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const { SearchBar } = Search;

  const columns = [
    {
      dataField: "normativGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      editable: false,
      formatter: actionFormatter,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          let newArr = [...normatives];
          let item = newArr.find((p) => p.productGuid === row.productGuid);
          item.isActive = false;
          setNormatives(newArr);
          setIsDisabled(false);
        },
      },
    },
    {
      dataField: "name",
      text: translator("Name"),
      sort: true,
      editable: false,
    },
    {
      dataField: "unitOfMeasureName",
      text: translator("EditItem-UnitOfMeasure"),
      editable: false,
    },
    {
      dataField: "quantity",
      text: translator("InitialState-Quantity"),
      validator: (newValue, row, column) => {
        if (
          isNaN(newValue) ||
          newValue == "" ||
          !numbersAndDot.test(newValue)
        ) {
          return {
            valid: false,
            message: translator("QuantityNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("QuantityNotNegative"),
          };
        }

        if (newValue >= 10000) {
          return {
            valid: false,
            message: translator("QuantityMax10Thousand"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
  ];
  const handleToAdd = () => {
    setShowFilterModal(true);
  };
  const addFilterProducts = (filterProducts) => {
    let newArr = [...normatives];

    //svi koji su bili izbrisani u state isActive false
    let oldDeleted = newArr.filter((ar) =>
      normatives.find(
        (rm) => rm.productGuid === ar.productGuid && ar.isActive === false
      )
    );

    //vraćam ih na isActive true
    oldDeleted.forEach((el) => (el.isActive = true));

    //ukloniti treci niz iz statea
    newArr = newArr.filter(
      (ar) => !oldDeleted.find((rm) => rm.productGuid === ar.productGuid)
    );

    //vraćamo stare kao isActive true
    newArr = newArr.concat(oldDeleted);
    let addedProducts = filterProducts.filter(
      (item) => !newArr.find((rm) => rm.productGuid === item.productGuid)
    );

    let newProducts = addedProducts.map((prod) => ({
      normativGuid: null,
      productGuid: prod.productGuid,
      name: prod.name,
      unitOfMeasureName: prod.unitOfMeasureName,
      quantity: 0,
      isActive: true,
    }));
    newArr = newArr.concat(newProducts);
    setNormatives(newArr);
  };

  return (
    <>
      <div className="p-1 ml-1">
        <div className="container-fluid p-0">
          <div className="card-body mb-4">
            <ToolkitProvider
              keyField="productGuid"
              data={normatives.filter((item) => item.isActive === true)}
              columns={columns}
              search
            >
              {(props) => (
                <div>
                  <SearchBar
                    {...props.searchProps}
                    placeholder={translator("Search")}
                  />
                  <hr />
                  <ListAdminButtons
                    selectedItemsLength={normatives.length}
                    handleToAdd={handleToAdd}
                  />
                  {isLoading ? (
                    <SpinnerLoading />
                  ) : (
                    <BootstrapTable
                      {...props.baseProps}
                      noDataIndication={translator("No-Data")}
                      pagination={paginationFactory(options)}
                      cellEdit={cellEditFactory({
                        mode: "click",
                        blurToSave: true,
                      })}
                    />
                  )}
                </div>
              )}
            </ToolkitProvider>
            <div
              className="container-fluid mt-4"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              &nbsp;
              <button
                className="btn btn-primary"
                disabled={isDisabled}
                onClick={handleSubmit}
                type="button"
              >
                {translator("POS-New_EditPOS-Save")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
      <NormativesFilterModal
        show={showFilterModal}
        tenantId={tenantId}
        prodList={normatives.filter((item) => item.isActive === true)}
        handleHide={() => setShowFilterModal(false)}
        confirmAdd={addFilterProducts}
      />
    </>
  );
};

export default ItemNormative;
